import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import { PetService } from "../../services/PetsService";

export function useCountPets() {
  const { db } = useContext(CurrentUserContext);

  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_COUNT_PETS],
    () => PetService.getCountPetsRegisters(db),
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
